/** Must match server HubMethods in Buzzle.ZitadelBridge.Host.Application.Activity.HubMethods */

export const HubMethods = {
  Snapshot: "Snapshot",
  Activity: "Activity",
} as const;
